<template>
    <b-container>
        <b-row>
            <b-col>
                <app-title text="Manuales" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-text-input
                    placeholder="Buscar"
                    v-model="term"
                ></app-form-text-input>
            </b-col>
        </b-row>
        <div v-for="manual in manuals" :key="`manual_${manual.id}`">
            <b-row>
                <b-col>
                    <app-sub-title :text="manual.name" />
                </b-col>
            </b-row>
            <b-row>
                <b-col v-html="manual.embed_code"> </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import docRepository from '@repositories/documentation.repository';
export default {
    data: () => ({
        manualsList: [],
        term: ""
    }),
    computed: {
        manuals() {
            if (!this.term) return this.manualsList;

            return this.manualsList.filter(item =>
                item.name.toLowerCase().indexOf(this.term.toLowerCase()) !== -1
            );
        }
    },
    methods: {
        async loadManuals() {
            const dr = {...docRepository};
            try {
                const { data } = await dr.getManuals();
                this.manualsList = data;
            } catch(err) {
                this.handleErrors(err);
            }
        }
    },
    created() {
        this.loadManuals();
    }
};
</script>